import { Slot } from '@radix-ui/react-slot';
import { cn } from '@utils/cn';
import { forwardRef } from 'react';

import { sizeStyles } from '../sizes';
import { type BaseButtonProps } from '../types';
import { variantStyles } from '../variants';

const Button = forwardRef<HTMLButtonElement, BaseButtonProps>(
  (
    {
      className,
      variant = 'primary',
      size = 'base',
      children,
      asChild = false,
      id,
      ...props
    },
    ref,
  ) => {
    const styles = cn(variantStyles({ variant }), sizeStyles[size], className);

    const Comp = asChild ? Slot : 'button';

    return (
      <Comp
        {...props}
        disabled={props.disabled}
        className={styles}
        ref={ref}
        id={id}
      >
        {children}
      </Comp>
    );
  },
);

Button.displayName = 'Button';

export { Button };
